import fa from "~/locales/fa";
import en from "~/locales/en";

// This is the list of languages your application supports
export const supportedLngs = ["fa"];

// This is the language you want to use in case
// if the user language is not in the supportedLngs
export const fallbackLng = "fa";

export const supportedLngsWithoutFallback = supportedLngs.filter((lng) => lng !== fallbackLng);

// The default namespace of i18next is "translation", but you can customize it
// here
export const defaultNS = "translation";

export const resources = {
  fa: { translation: fa },
  // en: { translation: en },
};

export const LANGUAGES: { lng: string; name: string; local: string }[] = [
  { lng: "fa", name: "Persian", local: "ir" },
  // { lng: "en", name: "English", local: "us" },
];
